import {
  utils as commonUtils,
  finleyAssertUnreachable,
} from '@finley-technologies/common';
import { Explo } from '@finley-technologies/finley-types';

export const generateMissingIntegrationMessage = (params: {
  exploArtifactType: Explo.ExploArtifactType;
  exploPlacement: Explo.ExploPlacementAllOptionsType;
}): string => {
  const { exploArtifactType, exploPlacement } = params;
  const stratsType = commonUtils.toTitleCase(exploArtifactType);
  switch (exploPlacement) {
    case 'borrowerStratsPage':
    case 'lenderFacilitiesTab':
      return `Strats ${stratsType} has not been set up for this credit facility. Please contact your Customer Sales Manager to explore additional features.`;
    case 'lenderPortfolioTab':
    case 'limitedPartnersDashboard':
      return `Portfolio ${stratsType} has not been set up for this organization. Please contact your Customer Sales Manager to explore additional features.`;
    default:
      return finleyAssertUnreachable(exploPlacement);
  }
};
